import React from 'react';
import { Info } from 'lucide-react';
export function AboutSection() {
  return <section id="about" className="py-16 bg-white" data-id="element-16">
      <div className="container mx-auto px-4" data-id="element-17">
        <div className="bg-white p-8 rounded-lg shadow-md max-w-3xl mx-auto" data-id="element-18">
          <div className="flex items-center mb-6" data-id="element-19">
            <Info className="h-6 w-6 text-blue-500 mr-3" data-id="element-20" />
            <h3 className="text-xl font-semibold" data-id="element-21">About Sport Pro</h3>
          </div>
          <p className="text-gray-700 mb-4" data-id="element-22">
            We are building the premier social network for the sports industry,
            connecting players, teams, scouts, and sports professionals in one
            dynamic platform designed to showcase talent and create valuable
            connections.
          </p>
          <p className="text-gray-700" data-id="element-23">
            Our platform is built by sports enthusiasts, for sports enthusiasts.
            We're dedicated to helping you REVEAL YOURSELF and BUILD YOUR
            NETWORK in the sports industry to advance your career and discover
            new opportunities.
          </p>
        </div>
      </div>
    </section>;
}